<template>
  <div class="rangeGridComponent noselect">
    <div class="rangeGridInstance main">
      <div v-for="(row, i) in rows" class="rangeGridRow" :key="i">
        <div v-for="squareData in row" :key="squareData.squareString" class="rangeGridCell">
          <RangeGridSquare
            :squareString="squareData.squareString"
            :colorScheme="colorScheme"
            :comboStringsByColorIndex="squareData.comboStringsBySubrangeIndex"
            :filteredComboStringsByColorIndex="
              partitionExcludingBoard[squareData.squareString].comboStringsBySubrangeIndex
            "
            @startPaint="startPaint"
            @continuePaint="paint"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chunk from "lodash/chunk";
import { CARD_VALUES } from "../constants";
import RangeGridSquare from "./RangeGridSquare";
import { sortGridPartition } from "../helpers/cards";

export default {
  name: "RangeGrid",
  components: { RangeGridSquare },
  props: {
    partition: { type: Object, required: true },
    partitionExcludingBoard: { type: Object, required: true },
    colorScheme: { type: Array, required: true },
  },
  data() {
    return {};
  },
  computed: {
    rows() {
      return chunk(sortGridPartition(this.partition), CARD_VALUES.length);
    },
  },
  methods: {
    startPaint(squareString) {
      this.$emit("toggleSquare", squareString, true);
    },
    paint(squareString) {
      this.$emit("toggleSquare", squareString);
    },
  },
};
</script>

<style lang="scss" scoped>
.rangeGridComponent {
  width: 500px;
  height: 500px;
  position: relative;
}

.rangeGridInstance {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid black;
}

.rangeGridRow {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}

.rangeGridCell {
  flex: 1;
}
</style>
